module.exports = __webpack_public_path__ + "img/auction.3ad56310.png";